import { render, staticRenderFns } from "./Appbar.vue?vue&type=template&id=2c5de24e&scoped=true"
import script from "./Appbar.vue?vue&type=script&lang=js"
export * from "./Appbar.vue?vue&type=script&lang=js"
import style0 from "./Appbar.vue?vue&type=style&index=0&id=2c5de24e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5de24e",
  null
  
)

export default component.exports